import { connect } from "react-redux";
import { getViewportCategory } from "../../../state/modules/layout/selectors";
import {
  getCategoryChildLinks,
  getCategoryHeaderDescription
} from "../../../state/modules/category";

import { analyticsClickMoreMvt } from "../../../state/modules/analytics/actions";
import { withTranslation } from "../../translation";

import CategoryDescription from "./CategoryDescription";

const mapStateToProps = state => ({
  viewport: getViewportCategory(state),
  hasPills: !!getCategoryChildLinks(state),
  description: getCategoryHeaderDescription(state)
});

const mapDispatchToProps = dispatch => ({
  analyticsClickMoreMvt: () => dispatch(analyticsClickMoreMvt())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(CategoryDescription));
